<template>
  <div id="time-panel" v-if="updateTime">
    <div>数据更新时间: {{ time }}</div>
    <div>当期本机时间: {{ nowTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'TimePanel',
  props: {
    updateTime: '',
  },
  data() {
    return {
      currentTime: new Date(),
    }
  },
  mounted() {
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  },
  computed: {
    time() {
      return new Date(this.updateTime).toLocaleString()
    },
    nowTime() {
      return new Date(this.currentTime).toLocaleString();
    }
  }
}
</script>

<style lang="less">
  #time-panel {
    position: fixed;
    color: #fff;
    z-index: 101;
    top: 20px;
    left: 20px;
    font-size: 12px;
    div {
      margin-bottom: 4px;
    }
  }
</style>